function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import PictureComponent from "/components/core/picture/picture-component";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import DefaultProps from "./default-props";
import { StyledCarouselAssetComponent } from "./carousel-asset-component.scss";
import { useCallback, useMemo, useRef } from "react";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_USER_SWIPE } from "constants/bigbrain-event-types";
import classnames from "classnames";
const CarouselAssetComponent = (_param)=>{
    var { autoplay, imageHeight, horizontalPadding, slides, centerPadding, disableCenterModeStyle, pauseOnHover, transitionSpeed } = _param, rest = _object_without_properties(_param, [
        "autoplay",
        "imageHeight",
        "horizontalPadding",
        "slides",
        "centerPadding",
        "disableCenterModeStyle",
        "pauseOnHover",
        "transitionSpeed"
    ]);
    const assets = useMemo(()=>(slides || []).map((slide)=>{
            var _slide_asset;
            return slide === null || slide === void 0 ? void 0 : (_slide_asset = slide.asset) === null || _slide_asset === void 0 ? void 0 : _slide_asset.image;
        }), [
        slides
    ]);
    const isUserSlideRef = useRef(null);
    const slider = useRef(null);
    const currentIndex = useRef(0);
    const pauseCarouselOnEvent = useCallback(()=>{
        var _slider_current;
        return pauseOnHover && autoplay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickPause());
    }, [
        autoplay,
        pauseOnHover
    ]);
    const onItemClick = useCallback((event, slideIndex)=>{
        if (slideIndex !== currentIndex.current) {
            isUserSlideRef.current = true;
        }
        if (slideIndex === 0 && currentIndex.current === assets.length - 1) {
            var _slider_current;
            (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickNext();
            event.stopPropagation();
        }
        if (slideIndex === assets.length - 1 && currentIndex.current === 0) {
            slider.current.slickPrev();
            event.stopPropagation();
        }
    }, [
        assets
    ]);
    const itemRenderer = useCallback((image, index)=>/*#__PURE__*/ _jsx("div", {
            onClick: (event)=>onItemClick(event, index),
            children: /*#__PURE__*/ _jsx(PictureComponent, {
                className: "image-slide",
                src: image === null || image === void 0 ? void 0 : image.src,
                alt: image === null || image === void 0 ? void 0 : image.alt
            }, image === null || image === void 0 ? void 0 : image.src)
        }), [
        onItemClick
    ]);
    const onSlideSwipe = useCallback(()=>{
        isUserSlideRef.current = true;
        pauseCarouselOnEvent();
    }, [
        pauseCarouselOnEvent
    ]);
    const onSlideChange = useCallback((index)=>{
        if (isUserSlideRef.current) {
            var _assets_index;
            trackEvent(CAROUSEL_USER_SWIPE, {
                kind: (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.src,
                info1: index
            });
            isUserSlideRef.current = false;
        }
    }, [
        assets
    ]);
    const carouselProps = useMemo(()=>({
            items: assets,
            autoplay,
            beforeChange: (oldIndex, newIndex)=>{
                currentIndex.current = newIndex;
            },
            onRefSet: (ref)=>{
                slider.current = ref;
            },
            pauseOnHover,
            itemRenderer,
            speed: transitionSpeed,
            defaultIndex: 0,
            onChange: onSlideChange,
            onSwipe: onSlideSwipe,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: centerPadding || undefined,
            swipeToSlide: true
        }), [
        assets,
        autoplay,
        centerPadding,
        itemRenderer,
        onSlideChange,
        onSlideSwipe,
        pauseOnHover,
        transitionSpeed
    ]);
    return /*#__PURE__*/ _jsx(StyledCarouselAssetComponent, {
        onMouseEnter: pauseCarouselOnEvent,
        onMouseLeave: ()=>{
            var _slider_current;
            return pauseOnHover && autoplay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickPlay());
        },
        className: classnames("carousel-asset-component", {
            "default-style": disableCenterModeStyle
        }),
        style: {
            "--image-height": imageHeight,
            "--image-padding": horizontalPadding
        },
        children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, rest, carouselProps))
    });
};
CarouselAssetComponent.defaultProps = DefaultProps;
export default CarouselAssetComponent;
